import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Menu, Input, Button } from 'semantic-ui-react';
import update from 'react-addons-update';
import ReactTable from 'react-table';
import Infinite from 'react-infinite';
import { Popup } from 'semantic-ui-react';
import { Commons } from 'components';

import scroll from 'helpers/scroll';
import cm from 'helpers/commons';

const propTypes = {};

const defaultProps = {};

class StepTwoStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elements: [],
      heightIdx: 0,
      containerHeight: 550,
      defaultValue: 0,
      policyData: null,
      headers: [
        { header: 'ID', width: 120, isChecked: false },
        { header: '이름', width: 120 },
        { header: '사원번호', width: 120 },
        { header: '권한', width: 100 }
      ]
    };
  }

  componentWillMount() {
    // const { groupStaffList } = this.props;
    // this.scrollEvent(groupStaffList);
  }

  componentDidMount() {
    let windowH = $(window).height();
    let topMenuH = $('.top-menu').outerHeight();
    let bottomFormH = $('.bottom-form').outerHeight();

    let listH = windowH - (topMenuH + bottomFormH + 200 + 48);

    this.setState({
      containerHeight: update(this.state.param, { $set: listH })
    });
  }

  componentWillReceiveProps(nextProps) {
    const { groupStaffList } = nextProps;
    this.scrollEvent(groupStaffList);
  }

  scrollEvent = (list) => {
    if (list.length > 0) {
      this.setState({
        elements: this.buildElements(list, false),
        isInfiniteLoading: false
      });
    } else {
      this.setState({ elements: [] });
    }
  };

  handleInfiniteLoad = () => {
    const { groupStaffList } = this.props;
    const { elements, heightIdx, containerHeight } = this.state;
    const item = groupStaffList ? groupStaffList : null;

    let that = this;
    let elemLength = elements.length;
    let itemLength = item ? item.length : 0;
    const infiniteParm = scroll.event(item, elements, containerHeight, heightIdx, elemLength);

    if (elemLength < itemLength) {
      let data = this.buildElements(groupStaffList, false);
      this.setState({
        isInfiniteLoading: true,
        heightIdx: heightIdx + containerHeight
      });

      setTimeout(function() {
        that.setState({
          elements: that.state.elements.concat(data),
          heightIdx: infiniteParm.heightIdx,
          isInfiniteLoading: false
        });
      }, 500);
    } else {
      this.setState({
        isInfiniteLoading: false
      });
    }
  };

  buildElements = (item) => {
    let elements = [];
    if (!item) {
      return elements;
    }

    for (let i = 0; i < item.length; i++) {
      const temp = this.listItem(item[i]);

      if (temp) {
        elements.push(temp);
      }
    }

    return elements;
  };

  listItem = (item) => {
    let defaultVal = 0;
    let result = null;

    if (item) {
      const { headers } = this.state;
      const { staffChecked, data, sikdaePolicy, fn } = this.props;
      let count = 0;

      item.policy.forEach(async (data) => {
        if (data.type === 'LONGTERM') {
          count += 1;
          if (count === 1) {
            defaultVal = data.idx;
          } else {
            defaultVal = 0;
          }
        }
      });

      const policyData = {
        data: {
          policy: item.policy
        }
      };

      this.setState({ policyData: policyData });

      const headerInputBox = (
        <div>
          <Commons.DefaultSikdaePolicySelBox
            longterm={true}
            individual={true}
            sikdaeGroupVal={data.groupNum}
            sikdaePolicy={policyData}
            defaultValue={cm.valueCheck(item.sPolicy) ? defaultVal : item.sPolicy}
            handleChange={fn.selectBoxhandleChange}
            id={item.id}
            isBtn={false}
            isIcon={true}
          />
        </div>
      );

      const division = cm.trTdDivision(item.orgCode);
      let styles = [];
      headers.forEach((headerItem, index) => {
        styles.push({
          flex: `${headerItem.width} 0 auto`,
          width: headerItem.width,
          maxWidth: headerItem.width,
          padding: '10px 0'
        });
      });

      result = (
        <div className="rt-tr -odd" key={item.id}>
          <div className="rt-td" style={styles[0]}>
            {item.signid}
          </div>
          <div className="rt-td" style={styles[1]}>
            {item.name}
          </div>
          {division.map((divi, i) => {
            return (
              <div key={`divi${i}`} className="rt-td" style={{ flex: `100 0 auto`, width: 128, padding: '10px 0' }}>
                <Popup className="td-tooltip" inverted trigger={<span>{divi}</span>} content={divi} />
              </div>
            );
          })}
          <div className="rt-td" style={styles[2]}>
            {item.comidnum}
          </div>
          <div className="rt-td" style={styles[3]}>
            {item.grade.text}
          </div>
          <div className="rt-td" style={{ flex: '350 0 auto', width: 350, maxWidth: 350 }}>
            {headerInputBox}
          </div>
        </div>
      );

      // let result = cm.tableStaffDivisionSet(tdata, 2, item.orgCode);

      return result;
    } else {
      return null;
    }

    if (defaultVal !== 0) {
      this.setState({
        defaultValue: update(this.state.defaultValue, { $set: defaultVal })
      });
    }
  };

  elementInfiniteLoad = () => {
    return <Commons.LoadingBar style={{ height: '800px' }} />;
  };

  tBodyFunc = (state) => {
    const { elements, containerHeight, isInfiniteLoading } = this.state;
    return (
      <div className="rt-tbody" style={state.style}>
        <div className="rt-tr-group">
          <Infinite
            className="infinite-scroll"
            elementHeight={40}
            containerHeight={containerHeight}
            infiniteLoadBeginEdgeOffset={containerHeight - 50}
            onInfiniteLoad={this.handleInfiniteLoad}
            loadingSpinnerDelegate={this.elementInfiniteLoad()}
            isInfiniteLoading={isInfiniteLoading}
            handleScroll={this.scrollHandler}
          >
            {elements}
          </Infinite>
        </div>
      </div>
    );
  };

  scrollHandler = (e) => {
    const { data } = this.props;
    data.staffCheckedData.forEach((data) => {
      $('#' + data.id).prop('value', data['sPolicy']);
    });
  };

  noDataProps = (state) => {
    const { groupStaffList } = this.props;
    let dom = <div className="rt-noData">검색 결과가 없습니다.</div>;
    if (groupStaffList.length > 0) {
      dom = <div className="rt-noData"></div>;
    }

    return dom;
  };

  render() {
    const { sikdaePolicy, data, fn, groupNum, isWelfare } = this.props;
    const { elements, isInfiniteLoading, heightIdx, containerHeight, defaultValue, policyData, headers } = this.state;

    const headerInputBox = (
      <div>
        <Commons.DefaultSikdaePolicySelBox
          longterm={true}
          individual={true}
          sikdaeGroupVal={data.groupNum ? data.groupNum : groupNum}
          sikdaePolicy={policyData}
          defaultValue={0}
          handleChange={fn.selectBoxhandleChange}
          isBtn={true}
          btnFunc={fn.allBtn}
        />
        {/* <Button inverted color='black' onClick={ (e) => fn.allBtn("policy", groupNum) }>모두적용</Button> */}
      </div>
    );

    let header = cm.tableHeaderList(headers, 2, 'notMaxWidth');
    header.push({ header: headerInputBox, width: 350, headerClassName: 'header-input-box' });

    const fnuc = { fnChecked: null, move: null };
    const columns = scroll.header(header, fnuc);

    return (
      <div className="step-two-staff">
        <Menu fluid vertical className="vendysLeftMenu staff">
          <Menu.Item className="top" name="title">
            지급할 {isWelfare ? '복지' : '식대'}정책 선택
          </Menu.Item>
        </Menu>
        <ReactTable
          className="react-table"
          noDataText="검색 결과가 없습니다."
          columns={columns}
          sortable={false}
          resizable={false}
          showPagination={false}
          TbodyComponent={this.tBodyFunc}
          NoDataComponent={this.noDataProps}
        />
      </div>
    );
  }
}

StepTwoStaff.propTypes = propTypes;
StepTwoStaff.defaultProps = defaultProps;

StepTwoStaff = connect((state) => ({
  sikdaePolicy: state.commons.sikdaePolicy
}))(StepTwoStaff);

export default StepTwoStaff;
